import { Box } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Button from "../../../components/ui/Button";
import Text from "../../../components/ui/Text";

export const NextGame = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.8,
      },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <Box
      ref={sectionRef}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: { xs: "48px 16px", md: "80px 40px" },
        background: "linear-gradient(to right, #203FA9, #1D81EF, #203FA9)",
      }}
    >
      <Text
        component="h2"
        variant="h2"
        sx={{
          color: "#ffffff",
          marginBottom: 3,
          fontSize: { xs: "32px", md: "50px", fontWeight: 900 },
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "scale(1)" : "scale(0.8)",
          transition: "all 0.8s ease-out 0.2s",
          textAlign: "center",
        }}
      >
        Your next game could be full in minutes!
      </Text>
      <Text
        sx={{
          color: "#ffffff",
          opacity: isVisible ? 1 : 0,
          transition: "all 0.6s ease-out 0.4s",
          fontSize: "18px",
          textAlign: "center",
        }}
      >
        Join hundreds of organisers who've stopped chasing and started playing.
      </Text>
      <Button
        component={Link}
        to="/create-game"
        sx={{
          mt: 6,
          fontWeight: 500,
          fontSize: { xs: 18, md: 20 },
          height: { xs: 56, md: 48, lg: 56 },
          width: { xs: "100%", sm: "auto" },
          padding: { xs: "0 24px", md: "0 32px" },
          backgroundColor: "#000000",
          borderColor: "#000000",
          "&:hover": { backgroundColor: "#1a1a1a", borderColor: "#1a1a1a" },
          opacity: isVisible ? 1 : 0,
          transition: "all 0.6s ease-out 0.6s",
        }}
      >
        Launch your game for free
      </Button>
    </Box>
  );
};
